import { useIntl } from 'react-intl';
import { EmptyState } from '@rossum/components/empty-state/EmptyState';
import { IconCloudUpload } from '@rossum/ui/icons/tabler';
import {
  Button,
  CircularProgress,
  Stack,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';

export const EmptyData = ({
  datasetUploadInProgress,
  onUpload,
}: {
  datasetUploadInProgress: boolean;
  // Without it the data cannot be uploaded here.
  onUpload?: () => void;
}) => {
  const intl = useIntl();

  if (datasetUploadInProgress) {
    return (
      <Stack
        p={3}
        m="auto"
        height={1}
        spacing={3}
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
        <Typography variant="h5">
          {intl.formatMessage({
            id: 'features.datasets.importInProgress.title',
          })}
        </Typography>
      </Stack>
    );
  }

  return (
    // Fills the grid's overlay too, which is not a flex container.
    <Stack p={1} m="auto" height={1} justifyContent="center">
      <EmptyState
        variant="plain"
        title={intl.formatMessage({ id: 'features.datasets.data.empty.title' })}
        description={
          onUpload
            ? intl.formatMessage({
                id: 'features.datasets.data.empty.description',
              })
            : undefined
        }
        action={
          onUpload ? (
            <Button
              data-cy="dataset-empty-upload"
              variant="contained"
              startIcon={
                <SvgIcon>
                  <IconCloudUpload />
                </SvgIcon>
              }
              onClick={onUpload}
            >
              {intl.formatMessage({ id: 'features.datasets.data.upload' })}
            </Button>
          ) : undefined
        }
      />
    </Stack>
  );
};
